module.exports = __webpack_public_path__ + "static/img/08.db7c903.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/2/08.jpg
// module id = 765
// module chunks = 0